import React from 'react';
import { string } from 'prop-types';
import cx from 'classnames';
import {
    UA_SUNSET_LABEL,
    UA_SUNSET_MESSAGE,
    NEW_AD_USERS_SUNSET_MESSAGE,
    WARNING
} from '../../../helpers/constant';
import MessageWithStatus from '../../MessageWithStatus';

import styles from './styles.scss';


/*-------------     UASunsetDisclaimer          ------------------*/
export const UASunsetDisclaimer = ({ title, label, customStyle }) => {
    const innerCustomStyle = {
        toastContainer: customStyle ? customStyle.toastContainer : styles.messageDisclaimer
    }
    return <div className={cx(styles.UASunsetDisclaimer, customStyle)}>
        <MessageWithStatus
            type={WARNING}
            label={label}
            description={<span>{title}</span>}
            customStyle={innerCustomStyle}
        />
    </div>
}

UASunsetDisclaimer.propTypes = {
    title: string,
    label: string,
    customStyle: string
}

UASunsetDisclaimer.defaultProps = {
    title: UA_SUNSET_MESSAGE,
    label: UA_SUNSET_LABEL
}



/*-------------     NewAdUserSunsetDisclaimer          ------------------*/
export const NewAdUserSunsetDisclaimer = ({ title, customStyle }) => {

    return <div className={cx(styles.newAdUserSunsetDisclaimer, customStyle)}>
        {title}
    </div>
}

NewAdUserSunsetDisclaimer.propTypes = {
    title: string,
    customStyle: string
}

NewAdUserSunsetDisclaimer.defaultProps = {
    title: NEW_AD_USERS_SUNSET_MESSAGE
}